<div>
  <label for="politicallyExposed">
    <p class="title">Är du en person i politiskt utsatt ställning, familjemedlem
      eller nära medarbetare till en person i politiskt utsatt ställning?
      <a
        spbAccessibleLink
        href="https://www.swedishbankers.se/foer-bankkunder/penningtvaett/personer-i-politisk-utsatt-staellning-pep"
        target="_blank">Läs mer genom att klicka här</a>
    </p>
  </label>
  <mat-radio-group #input="ngModel" [(ngModel)]="model"
                   id="politicallyExposed" required>
    <mat-radio-button [value]="true">Ja</mat-radio-button>
    <mat-radio-button [value]="false">Nej</mat-radio-button>
  </mat-radio-group>

  @if (input.errors) {
    <mat-error>Vänligen kontrollera fältet</mat-error>
  }

  @if (input.errors && input.touched) {
    <mat-icon matIconSuffix aria-hidden="true">
      priority_high
    </mat-icon>
  }
</div>